import {
  Button,
  Card,
  Col,
  notification,
  Popconfirm,
  Row,
  Table,
  Tooltip,
  Icon
} from 'antd'
import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import Request from '../../../request'
import PageHeaderWrapper from '../../../components/PageHeaderWrapper'
import SEODrawer from '../drawer'

const SEOList = () => {
    const [data, setData] = useState([])
    const [loading, setLoading] = useState(false)
    const [drawerVisible, setDrawerVisible] = useState(false)
    const [editData, setEditData] = useState(null)

    const fetchSEO = async () => {
        setLoading(true)
        const res = await Request.getAllSEO()
        if (res.success) {
            setData(res.data)
        } else {
            notification.error({ message: 'Error fetching SEO data' })
        }
        setLoading(false)
    }

    useEffect(() => {
        fetchSEO()
    }, [])

    const showDrawer = (record = null) => {
        setEditData(record)
        setDrawerVisible(true)
    }

    const closeDrawer = (refresh = false) => {
        setDrawerVisible(false)
        setEditData(null)
        if (refresh) fetchSEO()
    }

    const columns = [
        {
            title: 'Path',
            dataIndex: 'path',
            key: 'path',
            render: text => <a>{text}</a>
        },
        {
            title: 'Title',
            dataIndex: 'title',
            key: 'title',
        },
        {
            title: 'Description',
            dataIndex: 'description',
            key: 'description',
            ellipsis: true,
        },
        {
            title: 'Page Type',
            dataIndex: 'pageType',
            key: 'pageType',
        },
        {
            title: 'Action',
            key: 'action',
            render: (text, record) => (
                <span>
                    <Tooltip title="Edit">
                        <Button
                            shape="circle"
                            icon="edit"
                            onClick={() => showDrawer(record)}
                            style={{ marginRight: 8 }}
                        />
                    </Tooltip>
                </span>
            ),
        },
    ]

    return (
        <PageHeaderWrapper title="SEO Management">
            <Card bordered={false}>
                <div style={{ marginBottom: 16 }}>
                    <Button type="primary" icon="plus" onClick={() => showDrawer()}>
                        Add New SEO Record
                    </Button>
                </div>
                <Table
                    columns={columns}
                    dataSource={data}
                    rowKey="_id"
                    loading={loading}
                    pagination={{ pageSize: 10 }}
                />
            </Card>
            {drawerVisible && (
                <SEODrawer
                    visible={drawerVisible}
                    onClose={closeDrawer}
                    editData={editData}
                />
            )}
        </PageHeaderWrapper>
    )
}

export default SEOList
